import { useMutation } from "@tanstack/react-query";

import { updateConsultationLink } from "~/providers/api/consultationLinks";

export const useUpdateConsultationLink = () => {
  return useMutation({
    mutationFn: updateConsultationLink,
  });
};
